import {
  RESET_CUSTOMER_METADATA_ISFETCHING,
  CUSTOMER_METADATA_REQUESTING,
  LIST_CUSTOMER_METADATA_SUCCESS
} from './constants';

const INITIAL_STATE = {
  data: null,
  query: null,
  recordCount: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_METADATA_ISFETCHING: {
      return {
        ...state,
        isFetching: false,
        query: null,
        recordCount: null
      };
    }
    case CUSTOMER_METADATA_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_CUSTOMER_METADATA_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.metaDataConfigs.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        data,
        query,
        recordCount: action.payload.total,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
